// Shared config for the Family Feedback Form & Discharge Interview form + print.

export const FAMILY_LIKERT_LEGEND = [
  { n: 1, label: "Strongly Disagree / Very Poor" },
  { n: 2, label: "Disagree / Poor" },
  { n: 3, label: "Neutral / Average" },
  { n: 4, label: "Agree / Good" },
  { n: 5, label: "Strongly Agree / Excellent" },
];

export const FAMILY_SECTIONS = [
  {
    title: "Section B: Admission & Orientation",
    questions: [
      { key: "b1_purpose", label: "How clearly was the purpose of admission explained?" },
      { key: "b2_organized", label: "How organized was the admission process?" },
      { key: "b3_comfortable", label: "How comfortable did you feel during admission?" },
      { key: "b4_concerns", label: "Were your initial concerns addressed?" },
    ],
  },
  {
    title: "Section C: Care & Treatment",
    questions: [
      { key: "c1_informed_plan", label: "How well were you informed about the treatment plan?" },
      { key: "c2_involved_decision", label: "How involved were you in decision-making?" },
      { key: "c3_appropriate_treatment", label: "How appropriate was the treatment for client needs?" },
      { key: "c4_overall_care", label: "How satisfied are you with overall care?" },
    ],
  },
  {
    title: "Section D: Communication & Support",
    questions: [
      { key: "d1_clear_comm", label: "How clear was communication from staff?" },
      { key: "d2_easy_contact", label: "How easy was it to contact the team?" },
      { key: "d3_concerns_serious", label: "Were your concerns taken seriously?" },
      { key: "d4_supportive", label: "How supportive was the team overall?" },
    ],
  },
  {
    title: "Section E: Living Skills (Daily Life)",
    questions: [
      { key: "e1_hygiene", label: "Improvement in hygiene and self-care?" },
      { key: "e2_daily_routine", label: "Improvement in daily routine?" },
      { key: "e3_independence", label: "Independence in managing personal tasks?" },
      { key: "e4_consistency", label: "Consistency in daily habits?" },
    ],
  },
  {
    title: "Section F: Learning Skills",
    questions: [
      { key: "f1_focus", label: "Ability to focus and attend sessions?" },
      { key: "f2_understanding", label: "Understanding of instructions?" },
      { key: "f3_participation", label: "Participation in activities?" },
      { key: "f4_learning_new", label: "Learning new skills?" },
    ],
  },
  {
    title: "Section G: Social Skills",
    questions: [
      { key: "g1_communication", label: "Improvement in communication with others?" },
      { key: "g2_group_comfort", label: "Comfort in group settings?" },
      { key: "g3_respectful", label: "Respectful interaction with peers?" },
      { key: "g4_conflicts", label: "Handling conflicts?" },
    ],
  },
  {
    title: "Section H: Working Skills",
    questions: [
      { key: "h1_structured", label: "Participation in structured activities?" },
      { key: "h2_responsibility", label: "Responsibility in assigned tasks?" },
      { key: "h3_motivation", label: "Motivation to work or study?" },
      { key: "h4_vocational", label: "Readiness for vocational activities?" },
    ],
  },
  {
    title: "Section I: Clinical Progress",
    questions: [
      { key: "i1_symptoms", label: "Improvement in symptoms?" },
      { key: "i2_medication", label: "Understanding of medication?" },
      { key: "i3_stress", label: "Ability to manage stress?" },
      { key: "i4_relapse", label: "Awareness of relapse signs?" },
    ],
  },
  {
    title: "Section J: Discharge Planning",
    questions: [
      { key: "j1_explained", label: "Was discharge planning explained clearly?" },
      { key: "j2_prepared_home", label: "Do you feel prepared for home care?" },
      { key: "j3_followup_clear", label: "Was follow-up plan clear?" },
      { key: "j4_confidence", label: "Confidence in managing client after discharge?" },
    ],
  },
  {
    title: "Section K: Overall Feedback",
    questions: [
      { key: "k1_overall_satisfaction", label: "Overall satisfaction with services?" },
      { key: "k2_recommend", label: "Would you recommend TRH?" },
      { key: "k3_return", label: "Would you return if needed?" },
      { key: "k4_quality", label: "Quality of overall experience?" },
    ],
  },
];

export const FAMILY_QUESTION_KEYS = FAMILY_SECTIONS.flatMap((s) => s.questions.map((q) => q.key));
